var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AgentNavigator.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-04e9d029\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AgentNavigator.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/github/workspace/src/components/people/agents/AgentNavigator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AgentNavigator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04e9d029", Component.options)
  } else {
    hotAPI.reload("data-v-04e9d029", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/people/agents/AgentNavigator.vue
// module id = 1186
// module chunks = 0